// Shared date formatter for admin views. Keeps the "Mon D, YYYY" display in one place.
export function formatDate(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
